import React, { useEffect, useRef, useState } from "react";
import { FaPen } from "react-icons/fa6";
import "../Home/homePage.css";
import Sidebar from "../Sidebar/sidebar";
import TopNavbar from "../Navabr/navbar";
import { notification, Upload, Flex, Spin } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import {fetchIpAddress} from '../../../controllers/API';
import {updateProfile} from '../../../controllers/investor/accounts'
import { NOIMAGE } from "../../../config/constants";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const targetRef = useRef();
  const navigate = useNavigate();
  const USERDATA = JSON.parse(sessionStorage.getItem('USER-INFO'));
  const [editMode, setEditMode] = useState(false);
  const [EDITDATA, setEditData] = useState(USERDATA || '');
  const [FIRMDATA, setFirmData] = useState(USERDATA?.firm || '');
  const [investorImage, setInvestorImage]=useState(USERDATA?.firm?.investor_image);
  const [tempInvestorImage, setTempInvestorImage]=useState('');
  const [isLoading, setIsLoading] = useState(false);
  const onChange = (e)=>{
    try {
      const {name, value} = e.target;
      setEditData((pre)=>({
        ...pre,
        [name] : value
      }))
    } catch (error) {
      
    }
  }
  const changeFirmData = async (e) => {
    const {name, value} = e.target;
    setFirmData((pre)=>(
      {
        ...pre,
        [name] : value
      }
    ))
  }

  const onContinue = async () => {
    setEditMode(false);
    navigate('/investor/dashboard');
  }

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const { investor_first_name, investor_last_name, investor_designation } = EDITDATA;
      const { investor_firm_name, investor_description } = FIRMDATA;

      // Validation
      if (!investor_first_name?.trim()) {
        notification.open({
          message: "Validation Error",
          description: "First Name cannot be empty.",
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
        setIsLoading(false);
        return;
      }
      if (!investor_designation?.trim()) {
        notification.open({
          message: "Validation Error",
          description: "Designation cannot be empty.",
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
        setIsLoading(false);
        return;
      }

      const ipAddress = await fetchIpAddress();
      let form = new FormData();
      form.append('investor_first_name',investor_first_name);
      form.append('investor_last_name',investor_last_name);
      form.append('investor_designation',investor_designation);
      form.append('investor_firm_name',investor_firm_name);
      // form.append('investor_description',investor_description);
      form.append('ipAddress',ipAddress);
      if(investorImage){
        form.append('file',investorImage)
      }
      const res = await updateProfile(form);
      if(res.status === true){
        setEditMode(false);
        notification.open({
          message: "Success",
          description: `Profile updated successfully.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
        navigate('/investor/dashboard');
      } else{
        notification.open({
          message: "Oops!",
          description: `${res?.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
      setIsLoading(false);
      setTempInvestorImage(null);
    } catch (error) {
      setIsLoading(false);
      setTempInvestorImage(null);
    }
  }

  useEffect(()=>{
    if(USERDATA?.firm?.first_time_login === true){
      console.log('inside use ef ftl');
      setEditMode(true);
    }
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    document.title = "Chiratae Ventures | Spotlight | Profile";
  },[]);

  // const handleImageChnage = (e) => {
  //   const len = e.fileList?.length;
  //   const index = len - 1;
  //   setInvestorImage(e.fileList[index]?.originFileObj);
  //   const tempImg = URL.createObjectURL(e.fileList[index]?.originFileObj);
  //   setTempInvestorImage(tempImg);
  // }

  const DESIGNATIONS = [
    "Analyst",
    "Senior Analyst",
    "Associate",
    "Senior Associate",
    "AVP",
    "VP",
    "SVP",
    "Principal",
    "Partner",
    "Director",
    "Managing Director",
    "Founder/CEO",
    "Others"
  ];
  
  // const [isOtherDesignation, setIsOtherDesignation] = useState(
  //   !DESIGNATIONS.includes(USERDATA?.investor_designation)
  // );
  
  // const [otherDesignation, setOtherDesignation] = useState(
  //   !DESIGNATIONS.includes(USERDATA?.investor_designation)
  //     ? USERDATA?.investor_designation || ""
  //     : ""
  // );
  const initialDesignation = USERDATA?.investor_designation?.trim() || "";
  const [isOtherDesignation, setIsOtherDesignation] = useState(
    initialDesignation !== "" && !DESIGNATIONS.includes(initialDesignation)
  );

  const [otherDesignation, setOtherDesignation] = useState(
    initialDesignation !== "" && !DESIGNATIONS.includes(initialDesignation)
      ? initialDesignation
      : ""
  );



  return (
    <>
      <TopNavbar></TopNavbar>
      <div className="main-wrapper" ref={targetRef}> 
        <div>
          <Sidebar />
        </div>
        <div className="main_contant">
          <div className="container-fluid py-5 all_page_for_top_heading">
            <h2 className=" text-uppercase all_heading">Profile</h2>
            <div className="">
              <h4 className="profile_info_heading">Firm Info</h4>
              {/* <div className="d-flex align-items-center home_beepkart_fa_pen">
                {(tempInvestorImage && editMode) ? (
                  <img
                    src={tempInvestorImage}
                    alt="Logo"
                    className="profile-logo"
                    width='100px'
                  />
                ):(
                  <img
                    src={FIRMDATA?.investor_image || NOIMAGE}
                    alt="Logo"
                    className="profile-logo"
                    width='100px'
                  />
                )}
                {editMode && (
                  <Upload
                  showUploadList={false}
                  progress={false}
                  onChange={handleImageChnage}
                  multiple={false}
                  >
                    <div className="position-relative">
                      <button className="btn btn-sm rounded-circle edit-btn home_fa_pen_button" style={{marginRight: "-30px"}}>
                        <FaPen />
                      </button>
                    </div>
                  </Upload>
                )}
              </div> */}
              <form>
                
                
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <input
                      type="text"
                      name="investor_firm_name"
                      id="investor_firm_name"
                      placeholder="Investor Company’s Name"
                      onChange={changeFirmData}
                      className="form-control all_input"
                      disabled={true}
                      value={FIRMDATA.investor_firm_name}
                    />
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-md-12 mb-3">
                    <textarea
                      name="investor_description"
                      id="investor_description"
                      className="form-control all_input_text_area"
                      placeholder="Description"
                      rows="4"
                      onChange={changeFirmData}
                      disabled={true}
                      value={FIRMDATA.investor_description}
                    ></textarea>
                  </div>
                </div> */}

                <h4 className="profile_info_heading">User's Info</h4>
                <div className="row">
                  <div className="col-md-4 mb-2">
                    <input
                      type="text"
                      name="investor_first_name"
                      id="investor_first_name"
                      placeholder="First Name"
                      className="form-control all_input"
                      onChange={onChange}
                      disabled={!editMode}
                      value={EDITDATA?.investor_first_name}
                    />
                  </div>
                  <div className="col-md-4 mb-2">
                    <input
                      type="text"
                      name="investor_last_name"
                      id="investor_last_name"
                      placeholder="Last Name"
                      className="form-control all_input"
                      onChange={onChange}
                      disabled={!editMode}
                      value={EDITDATA?.investor_last_name}
                    />
                  </div>
                  {/* <div className="col-md-4 mb-3">
                    <input
                      type="text"
                      name="investor_designation"
                      id="investor_designation"
                      placeholder="Designation"
                      onChange={onChange}
                      className="form-control all_input"
                      disabled={!editMode}
                      value={EDITDATA?.investor_designation}
                    />
                  </div> */}
                  <div className="col-md-4 mb-3">
                    <select
                      name="investor_designation"
                      id="investor_designation"
                      className="form-control all_input"
                      disabled={!editMode}
                      value={
                        isOtherDesignation
                          ? "Others"
                          : EDITDATA?.investor_designation || ""
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                      
                        if (value === "Others") {
                          setIsOtherDesignation(true);
                          setEditData((prev) => ({
                            ...prev,
                            investor_designation: otherDesignation
                          }));
                        } else {
                          setIsOtherDesignation(false);
                          setEditData((prev) => ({
                            ...prev,
                            investor_designation: value
                          }));
                        }
                      }}
                    >
                      <option value="" style={{ fontWeight: "bold" }}>
                        Select Designation
                      </option>
                      {DESIGNATIONS.map((designation) => (
                        <option key={designation} value={designation}>
                          {designation}
                        </option>
                      ))}
                    </select>
                    
                    {isOtherDesignation && (
                      <input
                        type="text"
                        className="form-control all_input mt-2"
                        placeholder="Enter your designation"
                        value={otherDesignation}
                        disabled={!editMode}
                        onChange={(e) => {
                          const value = e.target.value;
                          setOtherDesignation(value);
                          setEditData((prev) => ({
                            ...prev,
                            investor_designation: value
                          }));
                        }}
                      />
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-4 mb-3">
                    <input
                      type="email"
                      name="investor_email"
                      id="investor_email"
                      placeholder="Email Address"
                      className="form-control all_input"
                      disabled={!editMode}
                      value={EDITDATA?.investor_email}
                    />
                  </div>
                  <div className="col-md-4 mb-3">
                    <input
                      type="Number"
                      name="investor_phone"
                      id="investor_phone"
                      placeholder="Mobile Number"
                      className="form-control all_input"
                      disabled={!editMode}
                      value={EDITDATA?.investor_phone}
                    />
                  </div>
                </div>
                
                <div className="d-flex">
                {editMode === true ?(
                  <div className="profile_submit_btn">
                    <button type="button" onClick={onSubmit}>Save & Continue</button>
                  </div>
                ):(
                  <>
                  {/* <div className="d-flex"> */}
                      <div className="profile_submit_btn">
                        <button type="button" onClick={()=>setEditMode(true)}>Edit Details</button>
                      </div>
                      {/* <div className="profile_submit_btn mx-2">
                        <button type="button" onClick={onSubmit}>Continue With Existing</button>
                      </div> */}
                  {/* </div> */}
                  </>
                )}
                {USERDATA.first_time_login === true && (
                  <div className="profile_submit_btn mx-2">
                    <button type="button" onClick={onSubmit}>Continue With Existing</button>
                  </div>
                )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Flex align="center" gap="middle">
        <Spin 
            size="large" 
            spinning={isLoading}
            fullscreen={true}
        />
      </Flex>
    </>
  );
}

export default Profile;
